/* eslint-disable */

/* tslint:disable */

/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export var VimeAudio = /*@__PURE__*/createReactComponent('vime-audio');
export var VimeCaptionControl = /*@__PURE__*/createReactComponent('vime-caption-control');
export var VimeCaptions = /*@__PURE__*/createReactComponent('vime-captions');
export var VimeClickToPlay = /*@__PURE__*/createReactComponent('vime-click-to-play');
export var VimeControl = /*@__PURE__*/createReactComponent('vime-control');
export var VimeControlGroup = /*@__PURE__*/createReactComponent('vime-control-group');
export var VimeControlSpacer = /*@__PURE__*/createReactComponent('vime-control-spacer');
export var VimeControls = /*@__PURE__*/createReactComponent('vime-controls');
export var VimeCurrentTime = /*@__PURE__*/createReactComponent('vime-current-time');
export var VimeDailymotion = /*@__PURE__*/createReactComponent('vime-dailymotion');
export var VimeDash = /*@__PURE__*/createReactComponent('vime-dash');
export var VimeDblClickFullscreen = /*@__PURE__*/createReactComponent('vime-dbl-click-fullscreen');
export var VimeDefaultControls = /*@__PURE__*/createReactComponent('vime-default-controls');
export var VimeDefaultSettings = /*@__PURE__*/createReactComponent('vime-default-settings');
export var VimeDefaultUi = /*@__PURE__*/createReactComponent('vime-default-ui');
export var VimeEmbed = /*@__PURE__*/createReactComponent('vime-embed');
export var VimeEndTime = /*@__PURE__*/createReactComponent('vime-end-time');
export var VimeFaketube = /*@__PURE__*/createReactComponent('vime-faketube');
export var VimeFile = /*@__PURE__*/createReactComponent('vime-file');
export var VimeFullscreenControl = /*@__PURE__*/createReactComponent('vime-fullscreen-control');
export var VimeHls = /*@__PURE__*/createReactComponent('vime-hls');
export var VimeIcon = /*@__PURE__*/createReactComponent('vime-icon');
export var VimeIcons = /*@__PURE__*/createReactComponent('vime-icons');
export var VimeLiveIndicator = /*@__PURE__*/createReactComponent('vime-live-indicator');
export var VimeMenu = /*@__PURE__*/createReactComponent('vime-menu');
export var VimeMenuItem = /*@__PURE__*/createReactComponent('vime-menu-item');
export var VimeMenuRadio = /*@__PURE__*/createReactComponent('vime-menu-radio');
export var VimeMenuRadioGroup = /*@__PURE__*/createReactComponent('vime-menu-radio-group');
export var VimeMuteControl = /*@__PURE__*/createReactComponent('vime-mute-control');
export var VimePipControl = /*@__PURE__*/createReactComponent('vime-pip-control');
export var VimePlaybackControl = /*@__PURE__*/createReactComponent('vime-playback-control');
export var VimePlayer = /*@__PURE__*/createReactComponent('vime-player');
export var VimePoster = /*@__PURE__*/createReactComponent('vime-poster');
export var VimeScrim = /*@__PURE__*/createReactComponent('vime-scrim');
export var VimeScrubberControl = /*@__PURE__*/createReactComponent('vime-scrubber-control');
export var VimeSettings = /*@__PURE__*/createReactComponent('vime-settings');
export var VimeSettingsControl = /*@__PURE__*/createReactComponent('vime-settings-control');
export var VimeSkeleton = /*@__PURE__*/createReactComponent('vime-skeleton');
export var VimeSlider = /*@__PURE__*/createReactComponent('vime-slider');
export var VimeSpinner = /*@__PURE__*/createReactComponent('vime-spinner');
export var VimeSubmenu = /*@__PURE__*/createReactComponent('vime-submenu');
export var VimeTime = /*@__PURE__*/createReactComponent('vime-time');
export var VimeTimeProgress = /*@__PURE__*/createReactComponent('vime-time-progress');
export var VimeTooltip = /*@__PURE__*/createReactComponent('vime-tooltip');
export var VimeUi = /*@__PURE__*/createReactComponent('vime-ui');
export var VimeVideo = /*@__PURE__*/createReactComponent('vime-video');
export var VimeVimeo = /*@__PURE__*/createReactComponent('vime-vimeo');
export var VimeVolumeControl = /*@__PURE__*/createReactComponent('vime-volume-control');
export var VimeYoutube = /*@__PURE__*/createReactComponent('vime-youtube');